import React from "react";

import { Container, Modal, Button } from "react-bootstrap";

import { FaTrashAlt } from "react-icons/fa";
import { deletePesticide } from "../../../controllers/ControllerPesticide";

export default function DeletePesticideModal(props) {
  const {
    showDeletePesticideModal,
    setShowDeletePesticideModal,
    getData,
    code3c_id,
  } = props;

  function clearFields() {
    setShowDeletePesticideModal(false);
  }

  function handleClose() {
    setShowDeletePesticideModal(!showDeletePesticideModal);
  }

  async function handleDeletePesticide() {
    const response = await deletePesticide(
      showDeletePesticideModal.name,
      showDeletePesticideModal.id,
    );
    if (response) {
      getData(code3c_id);
      clearFields();
    }
  }

  return (
    <Container className="ubuntuFont">
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        className="ubuntuFont"
        show={showDeletePesticideModal.show}
        onHide={handleClose}
        centered
      >
        <Modal.Header className="text-center" closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center"
          >
            <FaTrashAlt className="text-danger" />
            &emsp;Apagar Produtor?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          Tem certeza que quer apagar o defensivo:&nbsp;
          {showDeletePesticideModal.name}?
          <Container className="my-3">
            <Button
              variant="danger"
              className="mr-2"
              onClick={() => handleDeletePesticide()}
              style={{ width: "120px" }}
            >
              Apagar
            </Button>
            <Button
              variant="dark"
              onClick={() => handleClose()}
              style={{ width: "120px" }}
            >
              Cancelar
            </Button>
          </Container>
        </Modal.Body>
      </Modal>
    </Container>
  );
}
